import { createFileRoute } from '@tanstack/react-router';
import { GroupRulesPage } from '@/features/obligations/GroupRulesPage';

/**
 * Le regole di un livello — l'azienda o un gruppo —, obblighi e task insieme (task 1921 e 1904). Nel menu è
 * «Regole del gruppo», in «Il mio lavoro»; ci si arriva anche da «Scadenze del team» e dalle sezioni
 * dei task di «Regole di lavoro».
 */
export const Route = createFileRoute('/_app/group-rules')({ component: GroupRulesPage });
